module.exports = __webpack_public_path__ + "static/media/culturas_fundo_2.f91a4e3f.jpg";